
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/optimizely",
      function () {
        return require("private-next-pages/destinations/optimizely.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/optimizely"])
      });
    }
  